import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

const COMPONENTS = [];

@NgModule({
	imports: [
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		PerfectScrollbarModule,
		CommonModule
	],
	declarations: [...COMPONENTS],
	exports: [...COMPONENTS]
})
export class WidgetsComponentsModule {}
